<template>
  <sub-nav>
    <b-nav-item v-for="(account,i) in $store.state.Session.accounts" :key="account.eno"
      href="#" @click="$emit('click')" link-classes="pb-0 pt-0">
      <router-link v-if="account !== $store.getters.nowAccount" 
        :to="'/change/'+i">
        <b-avatar class="mr-0" size="1.25rem" :src="account.icon" />
        {{ account.nickname }}
      </router-link>
    </b-nav-item>
    <b-nav-item key="newsub" link-classes="pb-0 pt-0">
      <router-link to="/newsub" v-if="!$store.getters.test">
        <b-icon icon="check" class="icon" />サブキャラ登録
      </router-link>
    </b-nav-item>
    <b-nav-item key="logout"
      href="#" @click="$emit('click'); $emit('click::logout')" link-classes="pb-0 pt-0">
      <router-link to="/logout" v-if="$store.getters.test">
        <font-awesome-icon icon="sign-out-alt" class="icon" />テスト終了
      </router-link>
      <router-link to="/logout" v-else>
        <font-awesome-icon icon="sign-out-alt" class="icon" />ログアウト
      </router-link>
    </b-nav-item>
  </sub-nav>
</template>

<script>
import SubNav from './SubNav'
export default {
  name: 'account-nav',
  components: { SubNav }
}
</script>

<style lang="scss" scoped>
</style>
